import { render, staticRenderFns } from "./period-rule.vue?vue&type=template&id=7e8065af"
import script from "./period-rule.vue?vue&type=script&lang=js"
export * from "./period-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports